import React, { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import AlertUI from '../../generic/AlertUI'
import { apiDelete, apiGet, apiPost } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import IconButton from '@mui/material/IconButton'
import Edit from '@mui/icons-material/Edit'
import { PrecisionManufacturing, GridView } from '@mui/icons-material'

const SensorsActuatorsComponents = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [AlertElement, showAlert] = AlertUI()
  const showAlertReference = useRef()
  const { t_ } = useSmartTranslation()

  const fetchDevicesAndGroups = async () => {
    const devices = await apiGet('devicesBasicData')
    const deviceGroups = await apiGet('deviceGroups/simple')
    const combined = [
      ...devices.map(device => ({ id: device.id, name: device.name, group: false })),
      ...deviceGroups.map(group => ({ id: group.id, name: group.name, group: true }))
    ]
    return combined
  }

  useEffect(() => {
    showAlertReference.current = showAlert
  }, [showAlert])

  useEffect(() => {
    if (state === 'BACK') {
      showAlertReference.current({
        title: t_('There have been no modifications.'),
        severity: 'info'

      })
    } else if (state === 'EDIT') {
      showAlertReference.current({
        title: t_('Created correctly.'),
        severity: 'success'
      })
    }
  }, [state, t_])

  const columns = [{
    name: t_('Code'),
    field: 'code',
    readOnly: true,
    charLimit: 60,
    mandatory: true,
    unique: true
  },
  {
    name: t_('Name'),
    field: 'name',
    charLimit: 80,
    mandatory: true
  },
  {
    name: t_('Description'),
    field: 'description',
    charLimit: 200
  },
  {
    name: t_('Assets'),
    field: 'devices.name',
    type: 'smartMultiSelect',
    mandatory: true,
    iconFunction: (device) => {
      return device?.group ? <GridView /> : <PrecisionManufacturing />
    },
    edit: {
      source: fetchDevicesAndGroups,
      id: 'id',
      field: 'name'
    }
  },
  {
    name: t_('Type'),
    field: 'ioElementSetType.name',
    type: 'smartSelect',
    mandatory: true,
    edit: {
      source: async () => {
        return await apiGet('ioElementSetTypes')
      },
      id: 'id',
      field: 'name'
    }
  }
  ]

  const actions = {
    create: {
      fetchFunction: (row) => {
        return apiPost('ioElementSets', row)
      }
    },
    custom: [
      {
        name: 'Edit',
        render: (row) => (
          <IconButton>
            <Edit />
          </IconButton>
        ),
        onClick: (row) => {
          navigate('/configuration/sensorsActuatorsComponents/' + row.id, { replace: true })
        }
      }
    ],
    delete: {
      fetchFunction: (row) => {
        if (row.length === 1) {
          return apiDelete('ioElementSet/' + row[0].id, row)
        } else {
          return apiDelete('ioElementSetsMulti', row)
        }
      }
    }
  }
  const fetchFunction = async (pagination) => {
    const ioElementSets = await apiGet('ioElementSets', pagination)
    return ioElementSets
  }
  return (
    <>
      {AlertElement}
      <SmartMateriaUITable
        tableTuneUniqueKey='sensorsActuatorsComponent'
        columns={columns}
        title={t_('Sensors & Actuators components')}
        dataFetch={fetchFunction}
        actions={actions}
        multipleSelection
        pageable
      />

    </>
  )
}

export default SensorsActuatorsComponents
